import axios from 'axios';

if (!process.env.REACT_APP_API_WP_JSON_URL) {
	throw new Error('REACT_APP_API_WP_JSON_URL environment variable must be set');
}

export const API_WP_JSON_URL = process.env.REACT_APP_API_WP_JSON_URL;
export const API_WP_CONTENT_URL = process.env.REACT_APP_API_WP_CONTENT_URL;

export const api = axios.create({
	baseURL: `${API_WP_JSON_URL}`,
});
